export const validatePhoneNumber = (phoneNumber, type = "submit") => {
  if (type === "change") {
    return /^\d*$/.test(phoneNumber) && phoneNumber.length <= 8;
  }

  const regEx = /^([8-9]\d{7})$/;
  return regEx.test(phoneNumber);
};
